module.exports = __webpack_public_path__ + "static/media/IMG-2.6cb03998.jpg";